export const environment = {
  production: false,
  contactEmail: 'info@fruzty.com',
  apiUrl: 'https://api-dev.fruzty.com',
  apiSIIUrl: '',
  apiSIIToken: ''
};
